/* eslint-disable no-undef */
import './Hompage.scss';
import './HomepageMobile.scss';

import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Button from '@mui/material/Button';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useNavigate } from 'react-router-dom';

import {buttonStylesBlue, buttonStylesGreen } from '../../Components/docsAdministrative/JsObjectStyles';
import FooterConsulting from '../../Components/shared/Footer/FooterConsulting';
import NavbarConsulting from '../../Components/shared/Navbar/NavbarConsulting';
import { DrawFigure1, DrawFigure3, DrawIcon1, DrawIcon2, DrawIcon3, DrawIcon4, DrawIcon5, DrawIcon6 } from '../../data/SVGConsulting';
import { IconContainer1Home } from '../../data/SVGs';
import usePersistedLanguage from '../../hooks/usePersistedLanguage';
import useWindowSize from '../../hooks/useWindowSize';
import blog1 from './../../Assets/blogs/blog1.jpg';
import blog4 from './../../Assets/blogs/blog4.jpg';
import blog5 from './../../Assets/blogs/blog5.jpg';
import blog8 from './../../Assets/blogs/blog8.jpg';
import imgPlatform from './../../Assets/ConsultingHomePage/section_1_Consulting.png';
// ! why React becomes Too slow ..? SVG takes too much
// Could not find a declaration file for module 'react-trello'. 'C:/Users/Reda El Ouahabi/Desktop/HTH/hth_frontend/node_modules/react-trello/dist/index.js' implicitly has an 'any' type.
//   Try `npm i --save-dev @types/react-trello` if it exists or add a new declaration (.d.ts) file containing `declare module 'react-trello';

function HomePageConsulting() {

    // ! multiLanguages
    const { t, i18n } = useTranslation();

    // useEffect(() => {
    console.log(t, i18n);
    const navigate = useNavigate();
    usePersistedLanguage();
    //   return () => {
    //     second
    //   }
    // }, [])

    //! const index = 11;

    // alert("START")

    // const data = {
    //     lanes: [
    //         {
    //             id: 'lane1',
    //             title: 'Planned Tasks',
    //             label: '2/2',
    //             cards: [
    //                 { id: 'Card1', title: 'Write Blog', description: 'Can AI make memes', label: '30 mins', draggable: false },
    //                 { id: 'Card2', title: 'Pay Rent', description: 'Transfer via NEFT', label: '5 mins', metadata: { sha: 'be312a1' } }
    //             ]
    //         },
    //         {
    //             id: 'lane2',
    //             title: 'Completed',
    //             label: '0/0',
    //             cards: []
    //         }
    //     ]
    // }
    const { device } = useWindowSize();

    console.log('deviiice', device);
    return (
        <React.Fragment>
            <div
                className='App-intro'
                style={{background:'linear-gradient(171deg, rgba(255,255,255,1) 0%, rgba(229,243,235,1) 37%, rgba(232,238,253,1) 70%, rgba(255,255,255,1) 100%)'}}
            >
                <NavbarConsulting />

                <div className='rectangleP'>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '115px', alignItems: 'center', alignSelf: 'stretch' }}>
                        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', gap: '35px', alignSelf: 'stretch' }}>
                            <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', gap: '55px', alignSelf: 'stretch' }}>
                                <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', gap: '35px',padding:'30px', alignSelf: 'stretch' }}>
                                    <div
                                        className='frame105HomePage'
                                        style={{ paddingTop: device == 'desktop' ? '40px':'0px' }}
                                    >
                                        <div className='frame106HomePage'>
                                            <div className='frame107HomePage'>
                                                <div className='frame108HomePage'>
                                                    <h3 className='frame101HomePage'>
                                                        {i18n.t('Optimisez votre transformation digitale avec notre expertise IT!')}
                                                    </h3>
                                                    {device != 'desktop' &&
                                                        <div className='frame112HomePage'>
                                                            {/* <DrawFirstSvgHome /> */}
                                                            <img
                                                                src={imgPlatform}
                                                                style={{borderRadius:'22px'}}
                                                            />
                                                        </div>
                                                    }
                                                    <h6 className='frame110HomePage'>
                                                        {i18n.t('Faites équipe et boostez votre performance avec High Tech Hires, votre partenaire de confiance en consulting  IT pour propulser vos projets vers la réussite.')}
                                                    </h6>
                                                </div>
                                                <div className='frame111HomePage'>
                                                    <div className="frame0HomePage">
                                                        <Button
                                                            variant="contained"
                                                            style={{ ...buttonStylesGreen(false), ...{ height: '48px', width: device == 'desktop' ? 'fit-content' : '100%' } }}
                                                            onClick={() => {
                                                                navigate('/ConsultingServices');
                                                            }}
                                                            startIcon={<IconContainer1Home />}
                                                        > {i18n.t('Découvrir nos solutions')}
                                                        </Button></div>
                                                </div>
                                            </div>
                                            {device == 'desktop' &&
                                                <div className='frame112HomePage'>
                                                    <img
                                                        src={imgPlatform}
                                                        style={{borderRadius:'22px'}}
                                                    />
                                                </div>
                                            }
                                        </div>
                                        {/*<div className='frame113HomePage'>
                                            <h6 className='frame114HomePage'>Trusted by </h6>
                                            <div className='frame115HomePage'>
                                                <IconeTrustedBy1 />
                                                <IconeTrustedBy2 />
                                                <IconeTrustedBy3 />
                                                {device=='desktop' &&
                                                    <IconeTrustedBy4 />
                                                }
                                                <IconeTrustedBy5 />
                                            </div>
                                        </div>*/}
                                    </div>
                                    <div
                                        className='frame105HomePage'
                                        style={{width:'90%',height:'auto',borderRadius:'20px',padding:'20px'}}
                                    >
                                        <div
                                            className='frame106HomePage'
                                            style={{gap:device=='desktop' ? '40px':'16px'}}
                                        >
                                            <div
                                                className='frame112HomePage'
                                                style={{width:device=='desktop'?'45%':'100%',order:0,}}
                                            >
                                                <DrawFigure3 />
                                            </div>
                                            <div
                                                className='frame107HomePage'
                                                style={{width:device=='desktop'?'55%':'100%',order:1}}
                                            >
                                                <div className='frame108HomePage'>
                                                    <h3
                                                        className='frame101HomePage'
                                                        style={{fontSize:'40px'}}
                                                    >
                                                        {i18n.t('Votre partenaire ')}<span style={{color:'	#714B67',display:'contents'}}> Odoo </span>{i18n.t(' de confiance')}
                                                    </h3>
                                                    <div
                                                        className="horizontal-line-bottom"
                                                    ></div>
                                                    <h6 className='frame110HomePage'>
                                                        {i18n.t('En tant que partenaire officiel Odoo, nous accompagnons les entreprises dans la mise en place et l’optimisation de leur solution Odoo. Nous proposons des implémentations adaptées, une personnalisation sur mesure et une intégration fluide pour répondre aux besoins spécifiques de chaque activité.')}
                                                    </h6>
                                                    <h6 className='frame110HomePage'>
                                                        {i18n.t('Notre objectif est de vous aider à digitaliser et automatiser vos processus afin d\'améliorer votre efficacité et de soutenir votre croissance. Faites confiance à notre expertise pour tirer le meilleur parti d\'Odoo et simplifier la gestion de votre entreprise.')}
                                                    </h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className='frame98HomePage'
                                        style={{ marginTop: device == 'desktop' ? '70px' : '0px' }}
                                    >
                                        <div className='frame99HomePage'>
                                            <div className='frame100HomePage'>
                                                <h3 className='frame101HomePage'>{i18n.t('Vos Besoins, Nos Solutions ')} </h3>
                                                {device != 'desktop' &&
                                                    <div className='frame104HomePage'>
                                                        <DrawFigure1 />
                                                    </div>
                                                }
                                                <h6 className='frame110HomePage'>{i18n.t('Parce que chaque client est unique, nous adaptons des solutions sur mesure pour répondre précisément à vos besoins et garantir la réussite de vos projets.')}</h6>
                                            </div>
                                            <div className='frame103HomePage'>
                                                <Button
                                                    variant="contained"
                                                    sx={{ height: 56 }}
                                                    onClick={() => {
                                                        navigate('/ContactUs');
                                                    }}
                                                    style={{ ...buttonStylesBlue(), ...{ width: device == 'desktop' ? 'fit-content' : '100%' } }}
                                                    startIcon={<CalendarTodayIcon />}
                                                > {i18n.t('En savoir plus')}
                                                </Button>
                                            </div>
                                        </div>
                                        {device == 'desktop' &&
                                            <div className='frame104HomePage'>
                                                <DrawFigure1 />
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div
                                    className='frame5HomePage'
                                    style={{width:device == 'desktop'? '80%' : '91%'}}
                                >
                                    <div className='frame6HomePage'>
                                        <h3 className='frame101HomePage'>
                                            <Trans>
                                                {i18n.t('Nos points forts')}
                                            </Trans>
                                        </h3>
                                    </div>
                                    <div className='frame8HomePage'>
                                        <div
                                            className='frame9HomePage'
                                            style={{gridTemplateRows:'repeat(2, 1fr)'}}
                                        >
                                            <div
                                                className='frame10HomePage'
                                                style={{gap:'0px'}}
                                            >
                                                <div
                                                    className='frame11HomePage'
                                                    style={{width:'100%',height:'auto', gap:'10px', alignItems:'center'}}
                                                >
                                                    <div
                                                        className='frame12HomePage'
                                                        style={{height:'auto',width:'auto'}}
                                                    >
                                                        <DrawIcon1 />
                                                    </div>
                                                    <p
                                                        className='frame13HomePage'
                                                        style={{height:'auto',textAlign:'center', width:'auto'}}
                                                    >
                                                        {i18n.t('Expertise technique approfondie')}
                                                    </p>
                                                </div>
                                                {device == 'desktop' &&
                                                    <p
                                                        className='frame14HomePage'
                                                        style={{textAlign:'center'}}
                                                    >
                                                        {i18n.t('Grâce à une équipe de consultants hautement qualifiés, nous offrons des solutions IT innovantes et adaptées aux défis spécifiques de chaque client. Nous restons constamment à la pointe des dernières technologies pour garantir des conseils et des stratégies efficaces.')}
                                                    </p>
                                                }
                                            </div>
                                            <div
                                                className='frame10HomePage'
                                                style={{gap:'0px'}}
                                            >
                                                <div
                                                    className='frame11HomePage'
                                                    style={{width:'100%',height:'auto', gap:'10px', alignItems:'center'}}
                                                >
                                                    <div
                                                        className='frame12HomePage'
                                                        style={{height:'auto',width:'auto'}}
                                                    >
                                                        <DrawIcon2 />
                                                    </div>
                                                    <p
                                                        className='frame13HomePage'
                                                        style={{height:'auto',textAlign:'center', width:'auto'}}
                                                    >
                                                        {i18n.t('Approche sur mesure ')}
                                                    </p>
                                                </div>
                                                {device == 'desktop' &&
                                                    <p
                                                        className='frame14HomePage'
                                                        style={{textAlign:'center'}}
                                                    >
                                                        {i18n.t('Nous croyons en une collaboration étroite avec nos clients pour comprendre leurs objectifs, leurs contraintes et leurs attentes. Chaque solution que nous proposons est personnalisée pour répondre aux besoins uniques de votre entreprise, assurant une mise en œuvre optimale.')}
                                                    </p>
                                                }
                                            </div>
                                            <div
                                                className='frame10HomePage'
                                                style={{gap:'0px'}}
                                            >
                                                <div
                                                    className='frame11HomePage'
                                                    style={{width:'100%',height:'auto', gap:'10px', alignItems:'center'}}
                                                >
                                                    <div
                                                        className='frame12HomePage'
                                                        style={{height:'auto',width:'auto'}}
                                                    >
                                                        <DrawIcon3 />
                                                    </div>
                                                    <p
                                                        className='frame13HomePage'
                                                        style={{height:'auto',textAlign:'center', width:'auto'}}
                                                    >
                                                        {i18n.t('Engagement envers l\'innovation')}
                                                    </p>
                                                </div>
                                                {device == 'desktop' &&
                                                    <p
                                                        className='frame14HomePage'
                                                        style={{textAlign:'center'}}
                                                    >
                                                        {i18n.t('Notre mission est de guider votre entreprise dans son évolution numérique, en mettant en place des solutions modernes et évolutives qui favorisent l\'agilité, la compétitivité et la croissance durable à long terme.')}
                                                    </p>
                                                }
                                            </div>
                                            <div
                                                className='frame10HomePage'
                                                style={{gap:'0px'}}
                                            >
                                                <div
                                                    className='frame11HomePage'
                                                    style={{width:'100%',height:'auto', gap:'10px', alignItems:'center'}}
                                                >
                                                    <div
                                                        className='frame12HomePage'
                                                        style={{height:'auto',width:'auto'}}
                                                    >
                                                        <DrawIcon4 />
                                                    </div>
                                                    <p
                                                        className='frame13HomePage'
                                                        style={{height:'auto',textAlign:'center', width:'auto'}}
                                                    >
                                                        {i18n.t('Réactivité et soutien continu')}
                                                    </p>
                                                </div>
                                                {device == 'desktop' &&
                                                    <p
                                                        className='frame14HomePage'
                                                        style={{textAlign:'center'}}
                                                    >
                                                        {i18n.t('Nous offrons un accompagnement réactif et un support technique disponible à chaque étape de votre projet. Notre équipe est dédiée à résoudre rapidement vos défis et à garantir le bon fonctionnement de vos systèmes, minimisant ainsi les interruptions et maximisant votre productivité.')}                                                </p>
                                                }
                                            </div>
                                            <div
                                                className='frame10HomePage'
                                                style={{gap:'0px'}}
                                            >
                                                <div
                                                    className='frame11HomePage'
                                                    style={{width:'100%',height:'auto', gap:'10px', alignItems:'center'}}
                                                >
                                                    <div
                                                        className='frame12HomePage'
                                                        style={{height:'auto',width:'auto'}}
                                                    >
                                                        <DrawIcon5 />
                                                    </div>
                                                    <p
                                                        className='frame13HomePage'
                                                        style={{height:'auto',textAlign:'center', width:'auto'}}
                                                    >
                                                        {i18n.t('Méthodologie agile et flexible')}
                                                    </p>
                                                </div>
                                                {device == 'desktop' &&
                                                    <p
                                                        className='frame14HomePage'
                                                        style={{textAlign:'center'}}
                                                    >
                                                        {i18n.t('Nous appliquons des méthodes agiles pour garantir une gestion de projet fluide et adaptative, permettant de répondre rapidement aux évolutions du marché ou aux changements de priorités. Cette flexibilité assure que chaque projet est mené avec efficacité, dans les délais et budgets impartis.')}
                                                    </p>
                                                }
                                            </div>
                                            <div
                                                className='frame10HomePage'
                                                style={{gap:'0px'}}
                                            >
                                                <div
                                                    className='frame11HomePage'
                                                    style={{width:'100%',height:'auto', gap:'10px', alignItems:'center'}}
                                                >
                                                    <div
                                                        className='frame12HomePage'
                                                        style={{height:'auto',width:'auto'}}
                                                    >
                                                        <DrawIcon6 />
                                                    </div>
                                                    <p
                                                        className='frame13HomePage'
                                                        style={{height:'auto',textAlign:'center', width:'auto'}}
                                                    >
                                                        {i18n.t('Sécurité et conformité renforcées')}
                                                    </p>
                                                </div>
                                                {device == 'desktop' &&
                                                    <p
                                                        className='frame14HomePage'
                                                        style={{textAlign:'center'}}
                                                    >
                                                        {i18n.t('Nous priorisons la sécurité de vos données et veillons à ce que vos systèmes respectent les normes de conformité les plus strictes. En intégrant des protocoles de sécurité avancés et des pratiques de gestion des risques, nous protégeons vos informations sensibles et renforçons la résilience de votre infrastructure IT.')}</p>
                                                }
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        className='frame72HomePage'
                        style={{ paddingTop: device == 'desktop' ? '60px' : '0px' }}
                    >
                        <h3 className='frame101HomePage'> {i18n.t('Explorer Nos Blogs')}</h3>
                        <div className='frame75HomePage'>
                            <div
                                className='frame76HomePage'
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    navigate('/Consultingblogs/1');
                                }}
                            >
                                <div className='frame77HomePage'>
                                    <LazyLoadImage
                                        src={blog1}
                                        width={device == 'desktop' ? '600px' : '100%'}
                                        height={'396px'}
                                        style={{ borderRadius: '20px' }}
                                    />
                                </div>
                                <div
                                    className='frame78HomePage'
                                >
                                    <div className='frame79HomePage'>
                                        <p className='frame80HomePage'>
                                            2025
                                        </p>
                                        <h4 className='titlesociete'>
                                            {i18n.t('Les Tendances actuelles du Recrutement et du Consulting')}.
                                        </h4>
                                    </div>
                                    <p className='frame82HomePage'>
                                        {i18n.t('Par l\'équipe HTH')}
                                    </p>
                                </div>
                            </div>
                            <div className='frame83HomePage'>
                                <div className='frame84HomePage'>
                                    <h5 className='frame85HomePage'>
                                        {i18n.t('Articles en Vedette')}
                                    </h5>
                                    <div
                                        className='frame86HomePage'
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            navigate('/Consultingblogs');
                                        }}
                                    >
                                        <p
                                            className='frame87HomePage'
                                        >
                                            {i18n.t('Voir Plus')}
                                        </p>
                                        <div className='frame88HomePage'>
                                            <ChevronRightIcon />
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className='frame89HomePage'
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        navigate('/Consultingblogs/8');
                                    }}
                                >
                                    <div
                                        className='frame90HomePage'
                                        style={{ width: 'auto' }}
                                    >
                                        <LazyLoadImage
                                            src={blog8}
                                            width={'139px'}
                                            height={'139px'}
                                            style={{ borderRadius: '10px' }}
                                        />
                                    </div>
                                    <div
                                        className='frame91HomePage'

                                    >
                                        <div className='frame92HomePage'>
                                            <p
                                                className='frame93HomePage'
                                                style={{ margin: '0px' }}
                                            >
                                                2025
                                            </p>
                                            <div className='frame94HomePage'>
                                                <h6 className='blogTitles'>
                                                    {i18n.t('Comment Sécuriser efficacement les Données Sensibles sur le Cloud ?')}
                                                </h6>
                                            </div>
                                            <p
                                                className='frame95HomePage'
                                                style={{ margin: '0px' }}
                                            >
                                                {i18n.t('Par l\'équipe HTH')}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className='frame89HomePage'
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        navigate('/Consultingblogs/5');
                                    }}
                                >
                                    <div
                                        className='frame90HomePage'
                                        style={{ width: 'auto' }}
                                    >
                                        <LazyLoadImage
                                            src={blog5}
                                            width={'139px'}
                                            height={'139px'}
                                            style={{ borderRadius: '10px' }}
                                        />
                                    </div>
                                    <div
                                        className='frame91HomePage'

                                    >
                                        <div className='frame92HomePage'>
                                            <p
                                                className='frame93HomePage'
                                                style={{ margin: '0px' }}
                                            >
                                                2025
                                            </p>
                                            <div className='frame94HomePage'>
                                                <h6 className='blogTitles'>
                                                    {i18n.t('Comment Attirer les Meilleurs Talents lors du Processus de Recrutement?')}

                                                </h6>
                                            </div>
                                            <p
                                                className='frame95HomePage'
                                                style={{ margin: '0px' }}
                                            >
                                                {i18n.t('Par l\'équipe HTH')}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className='frame89HomePage'
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        navigate('/Consultingblogs/4');
                                    }}
                                >
                                    <div
                                        className='frame90HomePage'
                                        style={{ width: 'auto' }}
                                    >
                                        <LazyLoadImage
                                            src={blog4}
                                            width={'139px'}
                                            height={'139px'}
                                            style={{ borderRadius: '10px' }}
                                        />
                                    </div>
                                    <div
                                        className='frame91HomePage'

                                    >
                                        <div className='frame92HomePage'>
                                            <p
                                                className='frame93HomePage'
                                                style={{ margin: '0px' }}
                                            >
                                                2025
                                            </p>
                                            <div
                                                className='frame94HomePage'

                                            >
                                                <h6 className='blogTitles'>
                                                    {i18n.t('Les Défis de la Sécurité des Systèmes d’Information dans un Monde Big Data: Protéger les Données à l’Ère de l’Explosion des Données')}
                                                </h6>
                                            </div>
                                            <p
                                                className='frame95HomePage'
                                                style={{ margin: '0px' }}
                                            >
                                                {i18n.t('Par l\'équipe HTH')}
                                            </p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <FooterConsulting
                    styleProps={{background: '#005E23',
                    }}
                />
            </div>

            {/*<Footer
                styleProps={{
                    position: 'absolute',
                    left: '0px',
                    top: '5229.66px',
                    width: '100%'
                }} />*/}

        </React.Fragment>
    );
}

export default HomePageConsulting;